// @ts-nocheck
import alternatePackagingReducer, {
    GreifDataAlternatePackagingActions,
} from "@store/Framework/Store/Greif/Data/AlternatePackaging/AlternatePackagingReducer";
import shipmentsReducer, {
    GreifDataShipmentsActions,
} from "@store/Framework/Store/Greif/Data/Shipments/ShipmentsReducer";
import shipmentStatusesReducer, {
    GreifDataShipmentStatusesActions,
} from "@store/Framework/Store/Greif/Data/ShipmentStatusMapping/ShipmentStatusesReducer";
import taxExemptionCertificatesReducer, {
    GreifDataTaxExemptionCertificatesActions,
} from "@store/Framework/Store/Greif/Data/TaxExemptionCertificates/TaxExemptionCertificatesReducer";
import tecFinanceCompaniesReducer, {
    GreifDataTECFinanceCompaniesActions,
} from "@store/Framework/Store/Greif/Data/TECFinanceCompanies/TECFinanceCompaniesReducer";
import tecMessagesReducer, {
    GreifDataTECMessagesActions,
} from "@store/Framework/Store/Greif/Data/TECMessages/TECMessagesReducer";
import trailersReducer, { GreifDataTrailersActions } from "@store/Framework/Store/Greif/Data/Trailers/TrailersReducer";
import { combineReducers } from "redux";

const dataReducers = {
    taxExemptionCertificates: taxExemptionCertificatesReducer,
    tecFinanceCompanies: tecFinanceCompaniesReducer,
    tecMessages: tecMessagesReducer,
    productAlternatePackaging: alternatePackagingReducer,
    shipments: shipmentsReducer,
    shipmentStatuses: shipmentStatusesReducer,
    trailers: trailersReducer,
};

export type GreifDataActions =
    | GreifDataTaxExemptionCertificatesActions
    | GreifDataTECFinanceCompaniesActions
    | GreifDataTECMessagesActions
    | GreifDataAlternatePackagingActions
    | GreifDataShipmentsActions
    | GreifDataShipmentStatusesActions
    | GreifDataTrailersActions;
export default combineReducers(dataReducers);
